import type { RefundInfo } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useLazyQuery, useQuery } from '@apollo/client'

export interface RefundPosition {
  id: GQL_ID
  amount: number
  markCodes?: string[]
}

export interface PlaceOrderMutationResult {
  refundInfo: RefundInfo
}

export interface PlaceOrderMutationVariables {
  refundInfo: {
    orderId: GQL_ID
    positions?: RefundPosition[]
    refundMethod?: string
    returnToShop?: boolean
    fullRefund?: boolean
    returnDeliveryCost?: boolean
  }
}

const GQL_MUTATION_REFUND_POSITION = gql`
  query ($refundInfo: RefundInfoInput) {
    refundInfo: calculateRefund(refundInfo: $refundInfo) {
      id
      total
      deliveryTotal
      type
      isReturnedToShop
      isRefundedBeforeOrderClosing
      orderStatusOnRefund
    }
  }
`

export const useFetchCalculateRefund = (
  variables: PlaceOrderMutationVariables
) =>
  useQuery<PlaceOrderMutationResult, PlaceOrderMutationVariables>(
    GQL_MUTATION_REFUND_POSITION,
    { variables, fetchPolicy: 'network-only' }
  )

export const useLazyFetchCalculateRefund = () =>
  useLazyQuery<PlaceOrderMutationResult, PlaceOrderMutationVariables>(
    GQL_MUTATION_REFUND_POSITION
  )
